import { createSelector } from 'reselect';
import { IStoreState } from 'store';

const nonStandardRisksSelectors = (state: IStoreState) => state.fieldOptions.nonstandardRisks;
const selectedNonStandardRiskData = (state: IStoreState) => state.dealEdit.nonstandardRisks;

export const getNonStandardRiskData = createSelector(
  [nonStandardRisksSelectors, selectedNonStandardRiskData],
  (nonStandardRiskData, selectedNonStandardRisk) => {
    return nonStandardRiskData?.map(nsr => {
      if (selectedNonStandardRisk?.includes(nsr.displayName)) {
        return {
          ...nsr,
          options: [
            { radioName: 'Included', selected: true },
            { radioName: 'Not Included', selected: false },
          ],
        };
      }
      return {
        ...nsr,
        options: [
          { radioName: 'Included', selected: false },
          { radioName: 'Not Included', selected: true },
        ],
      };
    });
  }
);
